import { render } from "./TypeWriteComponent.vue?vue&type=template&id=89ccf386&scoped=true"
import script from "./TypeWriteComponent.vue?vue&type=script&lang=js"
export * from "./TypeWriteComponent.vue?vue&type=script&lang=js"

import "./TypeWriteComponent.vue?vue&type=style&index=0&id=89ccf386&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89ccf386"]])

export default __exports__